import type { SearchHistoryItem } from '@/src/stores/global-search/atom'
import { Group } from './group'
import { Item } from './item'
import type { SearchResult } from './types'
import { tokenId } from './types'

interface RecentAndTrendingProps {
  handleSelect: (item: SearchResult) => void
  handleHover?: (item: SearchResult) => void
  recentSearches: SearchHistoryItem[]
  trending: SearchResult[]
}

export const RecentAndTrending = ({
  handleSelect,
  handleHover,
  recentSearches,
  trending,
}: RecentAndTrendingProps) => {
  return (
    <>
      {recentSearches.length > 0 && (
        <Group heading='Recent searches'>
          {recentSearches.map((item) => (
            <Item
              item={item}
              prefix='recent'
              key={`recent-${tokenId(item)}`}
              onSelect={handleSelect}
              onHover={handleHover}
            />
          ))}
        </Group>
      )}

      <Group heading='Trending'>
        {trending.map((item) => (
          <Item
            item={item}
            prefix='trending'
            key={`trending-${tokenId(item)}`}
            onSelect={handleSelect}
            onHover={handleHover}
          />
        ))}
      </Group>
    </>
  )
}
